import BttfAxios from '@features/utils/axios';
import { AxiosResponse } from 'axios';
import { SettingsResponse } from '@appInterfaces/IBFAppSettings';

class SettingsClass {
  public get(): Promise<AxiosResponse<SettingsResponse>> {
    return BttfAxios.get(`/api/settings/`, resp => resp);
  }

}
const SettingsService = new SettingsClass();

export default SettingsService;
